import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleShowTotal } from 'store/filters/filters-actions';
import totalPriceChanged from 'segment/events/search/total-price-changed';
import { useShowTotal } from 'store/selectors/hooks/useShowTotal';
import { FilterCheckboxBase } from '../../../filter-bases';
import { persistTotalPriceSessionPreference } from 'utils/total-price-session-utils';
import { Switch, Box } from '@spothero/ui';
import { SearchPageView } from 'utils/search-page-view';
import { AllInPricingCallout } from 'common/all-in-pricing/AllInPricingCallout';
import { useAllInPricingVariant, ALL_IN_PRICING_VARIANTS, } from 'hooks/use-all-in-pricing-variant';
const DesktopTotalToggle = ({ showTotal, onChange, }) => (<Box flex="1 1 auto" justifySelf="flex-end" sx={{
        '.chakra-form-control': {
            display: 'flex',
            flexFlow: 'row-reverse',
            alignItems: 'center',
            gap: 2,
        },
        '.chakra-form__label': {
            marginBottom: 0,
        },
    }} data-testid="DesktopTotalToggle">
        <Switch label={'Show total price with fees'} isChecked={showTotal} onChange={onChange}/>
    </Box>);
export default function TotalToggle() {
    const eventsPopupOpen = useSelector((state) => state.search.data.eventsPopupOpen);
    const variant = useAllInPricingVariant();
    const dispatch = useDispatch();
    const state = useSelector((s) => s);
    const view = useSelector((s) => s.search.data.view);
    const showTotal = useShowTotal();
    const [isClient, setIsClient] = useState(false);
    const handleClick = () => {
        dispatch(toggleShowTotal(!showTotal));
        persistTotalPriceSessionPreference(!showTotal);
        totalPriceChanged(state);
    };
    useEffect(() => {
        setIsClient(true);
    }, []);
    if (!isClient || eventsPopupOpen) {
        // Early return
        return <div data-testid="notClient-totalToggle"/>;
    }
    // Handle desktop list view
    if (view === SearchPageView.DESKTOP_LIST) {
        return variant === ALL_IN_PRICING_VARIANTS.ON_WITH_MARKETING ? (<AllInPricingCallout />) : (<DesktopTotalToggle showTotal={showTotal} onChange={handleClick}/>);
    }
    // Handle mobile list and map views
    return variant === ALL_IN_PRICING_VARIANTS.ON_WITH_MARKETING ? null : (<FilterCheckboxBase testid={`QuickFilters-showTotal-${showTotal}`} onClick={handleClick} isActive={showTotal}>
            Total Price
        </FilterCheckboxBase>);
}
